export const ssnRegex = new RegExp(/^\d{10}$/);
